// import React, { useState, useEffect } from 'react';
// import * as language from '../constants/languages';
// import { getBranches } from '../services/services';

// export default function StoreChoose() {
//     // get the branch data
//     async function getBranchesFunction() {

//         await getBranches(language.companyidValue).then((branches) => {
//             if (branches.status === 'success') {
//                         const event = new CustomEvent('storeSelected', { detail: branches.data[branches.data.length-1].branchName });;
//                         localStorage.setItem('storeId', JSON.stringify(branches.data[branches.data.length-1].branchId));
//                         localStorage.setItem('storeName', branches.data[0].branchName);
//                         window.dispatchEvent(event)
//             }

//         })
//             .catch((error) => {
//                 // console.log(error, 'branch error');
//             })

//     }
//     useEffect(() => {
//         getBranchesFunction()
//     }, [])
// }

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CafeIcon from "../assets/svg/cafeicon.svg";
import CollegeLogo from "../assets/header_logo.png";
import { getBranches } from "../services/services";
import * as language from "../constants/languages";
import "../styles/StoreChoose.css";

export default function StoreChoose() {
  const navigate = useNavigate();

  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);

  // modal state
  const [showModal, setShowModal] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    try {
      setLoading(true);

      const response = await getBranches(language.companyidValue);
      console.log("Branch response:", response);

      if (response?.status === "success" && response?.data?.length > 0) {
        const formattedStores = response.data.map((item) => ({
          id: item.branchId,
          name: item.branchName?.trim(),
          image: CollegeLogo,
          address: item.address,
          phone: item.phoneNo1,
        }));

        setStores(formattedStores);
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
    } finally {
      setLoading(false);
    }
  };

  const showToast = (message) => {
  setToastMessage(message);

  setTimeout(() => {
    setToastMessage("");
  }, 2000);
};

// open modal on card click
 const handleStoreClick = (store) => {
  const cart = JSON.parse(
    localStorage.getItem("cartItems") || "{}"
  );

  console.log(cart, "cart data");

  const hasCartItems =
    Array.isArray(cart?.customerCartItems) &&
    cart.customerCartItems.length > 0;

  if (hasCartItems) {
    // open modal if cart has items
    setSelectedStore(store);
    setShowModal(true);
    return;
  }

  // cart empty → switch directly
  localStorage.setItem("storeId", JSON.stringify(store.id));
  localStorage.setItem("storeName", store.name);
  localStorage.setItem("storeChooseFlag", store.name);

  navigate("/home", { replace: true });
};

  // clear cart + switch branch
  const handleSwitchBranch = () => {
    if (!selectedStore) return;

    // clear previous cart
    localStorage.removeItem("cart");
    localStorage.removeItem("cartItems");
    localStorage.removeItem("checkoutData");

    // save selected branch
    localStorage.setItem("storeId", JSON.stringify(selectedStore.id));
    localStorage.setItem("storeName", selectedStore.name);
    localStorage.setItem("storeChooseFlag", selectedStore.name);

    setShowModal(false);
    showToast("Cart items removed successfully");

  setTimeout(() => {
    navigate("/home", { replace: true });
  }, 800);
  };

  // continue shopping without changing store
  const handleContinueShopping = () => {
    setShowModal(false);
    navigate("/home", { replace: true });
  };

  return (
    <div className="store-screen">
      {/* Header */}
      <div className="store-header">
        <div className="store-header-content">
          <img src={CafeIcon} alt="Cafe" className="store-icon" />
          <h1 className="store-title">Choose Store</h1>
        </div>
      </div>

      {/* Loader */}
      {loading ? (
        <div className="store-loader-container">
          <div className="store-loader"></div>
        </div>
      ) : (
        <div className="store-grid">
          {stores.map((store) => (
            <StoreCard
              key={store.id}
              name={store.name}
              image={store.image}
              onClick={() => handleStoreClick(store)}
            />
          ))}
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="store-modal-overlay">
          <div className="store-modal">
            <p className="store-modal-text">
              Your previous store cart will be cleared when switching branches.
            </p>

            <div className="store-modal-actions">
              <button
                className="store-modal-btn"
                onClick={handleSwitchBranch}
              >
                Switch Branch
              </button>

              <button
                className="store-modal-btn"
                onClick={handleContinueShopping}
              >
                Continue Shopping
              </button>
            </div>
          </div>
        </div>
      )}

      {toastMessage && (
  <div className="custom-toast">
    {toastMessage}
  </div>
)}
    </div>
  );
}

function StoreCard({ name, image, onClick }) {
  return (
    <div className="store-card" onClick={onClick}>
      <div className="store-card-image-wrapper">
        <img src={image} alt={name} className="store-card-image" />
      </div>
      <h2 className="store-card-title">{name}</h2>
    </div>
  );
}